import Button from '@components/Button';
import { Typography } from '@components/Typography';
import { useTranslation } from '@hooks';

const MicrositeFileUploader = ({ item, disabled, onChange, styles }) => {
    const { t } = useTranslation();

    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: 8,
                transform: 'translateY(-8px)',
                minWidth: 0,
                ...styles,
            }}
        >
            <Typography
                variant="caption"
                sx={{
                    flex: '1 1 auto',
                    minWidth: 0,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    color: 'rgba(0,0,0,0.6)',
                }}
            >
                {item?.fileUrl ? (
                    <a
                        href={item?.fileUrl}
                        style={{
                            color: '#1F4C5C',
                            display: 'block',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                        }}
                        target="_blank"
                        rel="noreferrer"
                    >
                        {t('ProfilesMedia.viewContent')}
                    </a>
                ) : (
                    t('common.noFileSelected')
                )}
            </Typography>
            <Button
                variant="outlined"
                aria-label="upload file"
                component="label"
                disabled={disabled}
                sx={{ flex: '0 0 auto' }}
            >
                <input hidden type="file" onChange={onChange} />
                {t(`buttons.${item?.fileUrl ? 'replace' : 'upload'}`)}
            </Button>
        </div>
    );
};

export default MicrositeFileUploader;
